import { useSweepApi } from '../sweep/useSweepApi';
import { useCallback } from 'react';
import type { UserAccount } from '@server/user-account';
import type { CreateAccount } from '@server/create-account';

export const useAccountSelectionApiFacade = () => {
  const sweepApi = useSweepApi();
  return {
    post_account: useCallback(
      async (account: CreateAccount): Promise<{ authZeroOrgId: string }> => {
        const response = await sweepApi.post(`/account-selection/accounts`, account);
        return response.data;
      },
      [sweepApi],
    ),
    get_accounts: useCallback(async () => {
      const response = await sweepApi.get<UserAccount[]>(`/account-selection/accounts`);
      return response.data;
    }, [sweepApi]),

    delete_account: useCallback(
      async (accountId: string) => {
        await sweepApi.delete(`/account-selection/accounts/${accountId}`);
      },
      [sweepApi],
    ),
  };
};
